const formTypeMap = {
  appointment: 'Appointment',
  chat: 'Chat',
  web_form: 'Web Form',
};

export default formTypeMap;
